import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AssessmentSelectorComponent } from '../assessment-selector/assessment-selector.component';
import { AuthService } from '../_services/auth.service';
import { ApiService } from '../_services/api.service';
import { ConfigService } from '../_services/config.service';
import { ExportComponent } from '../export/export.component';
import { AboutComponent } from '../about/about.component';
import { HelpComponent } from '../help/help.component';

@Component({
    selector: 'true-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent implements OnInit {
  public loggedIn: boolean;
  constructor(private route: ActivatedRoute, public readonly authService: AuthService, private api: ApiService, private router: Router, private dialog: MatDialog, public readonly config:ConfigService) { }

  ngOnInit(): void {
    this.authService.authenticated.subscribe((authenticated) => {
      this.loggedIn = authenticated;
    });
  }

  navigate(id): void {
    switch (id) {
      case 'home':
        this.router.navigate(['/home']);
        break;

      case 'nodes':
        this.router.navigate(['/nodes']);
        break

      case 'canvas':
        this.router.navigate(['/canvas']);
        break;

      case 'trl':
          this.router.navigate(['/trl']);
          break;

      case 'brief':
        this.router.navigate(['/brief']);
        break;
        
      case 'input':
        this.router.navigateByUrl('/scenarios', {skipLocationChange: true}).then(()=> {
          this.router.navigate(['input'])
        });
        
        break;

      case 'analysis':
        this.router.navigate(['analysis']);
        break;

      case 'scenarios':
        this.router.navigate(['scenarios']);
        break;
        
      case 'insights':
        this.router.navigate(['/insights']);
        break;
    }
  }
  
  activeClass(menuItems: string[]): string {
    for (const menuItem of menuItems) {
        if (this.route.snapshot['_routerState'].url.startsWith('/' + menuItem)) {
            return "selected";
        }
    }
    return "";
}

  usermanagement(): void {
    this.router.navigate(['users']);
  }

  chooseAssessment(): void {
    let dialogRef = this.dialog.open(AssessmentSelectorComponent, {
      height: '765px',
      width: '800px',
    });

    dialogRef.beforeClosed().subscribe(() => {
      window.location.reload();
    });
  }

  logout(): void {
    this.api.resetAssessment();
    this.authService.logout();
    this.router.navigate(['login']);
  }
  
  export(): void {
    let dialogRef = this.dialog.open(ExportComponent, {
      height: '400px',
      width: '600px',
    });
  }

  help(): void {
    if (this.config.pillar_models) {      
      window.open('/radiant/bm-dss/assets/pdf/Radiant_MAG_User_Manual.pdf', '_blank');
    } else {
      let dialogRef = this.dialog.open(HelpComponent, {
        height: '765px',
        width: '800px',
      });
    }
  }

  about(): void {
    let dialogRef = this.dialog.open(AboutComponent, {
      height: '765px',
      width: '800px',
    });
  }
}
